import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";

import "../components/Report.scss";
import ArrowRightCircleOutlineIcon from "mdi-react/ArrowRightCircleOutlineIcon";
import logo from "../components/img.png";
import Details from "../components/Details";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  buildingFL,
} from "../../../../../../shared/helpers/utils";
import {
  generatePeriodNames,
  prepareResForAI,
  filterAIData,
  getCurrentPeriod,
  getPriorPeriod,
  getRangeEnd,
  getRangeStart,
  formatDate,
  validateNestedData,
  percentageChange,
} from "../../../exportreport/utils";
import CustomTable from "../../components/CustomTable";
import CustomBarChart from "../components/CustomBarChart";
import HorizontalBarChart from "../../components/HorizontalBarChart";
import CustomLineChart from "../../components/CustomLineChart";
import UserProfile from "../../components/UserProfile";
import Header from "../components/Header";
import MultiBarChart from "../components/MultiBarChart";
import { building } from "../../../../../DataExport/components/EmptyExportList/components/EmptyList";
const apiURL = process.env.API_ROOT;

const BlendedLayout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    theme,
    formValues,
  } = props;

  const { dateOptions, branding } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions);
  const priorPeriod = getPriorPeriod(dateOptions);

  const priorYearPeriod = priorPeriod;
  const rangeEnd = getRangeEnd(dateOptions);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;

  useEffect(() => {
    console.log(searchTags, "searchTagsChintan");
    if (!reportData && !fetchInProgress && submit) {
      loadData();
      setSubmit(false);
    }
  }, [submit]);

  const loadData = async () => {
    let q = "*:*";
    let locQuery = _tranformTagsQuery(searchTags);

    if (locQuery) {
      q = locQuery;
    }

    const defaultQ = getCohortQuery(user, true);
    const fq = [
      ..._activityFQ.slice(),
      ...[
        `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
      ],
    ];
    setFetchInProgress(true);

    const buildingSlug =
      searchTags &&
      searchTags[0] &&
      searchTags[0].data &&
      searchTags[0].data.building_slugs &&
      searchTags[0].data.building_slugs[0];

    let axiosData = {
      url:
        process.env.API_ROOT +
        `/buildings/${buildingSlug}?type=minimum&cache=15`,
      method: "get",
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        let aiData;

        if (res && res.building) {
          // aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
          // // const aiResponse = await handleAIGenerate(aiData);
          // res["aiResponse"] = aiResponse;

          const statsResponse = await _getBuildingOPData(
            res.building[0],
            res.units
          );
          const turnOverRateResponse = await getTurnOverBuildingData(
            res.building[0]
          );
          const transResponse = await _getBuildingTransactionData(
            res.building[0]
          );
          const tableResponse = await _getBuildingTransactionTableData(
            res.building[0]
          );
          const allTransactionResponses = await _getTransactionData(
            res.building[0]
          );
          const taxResponse = await _getTaxes(res.building[0]);
           const lastTableResponse=await _TableData(res.building[0]);

          setReportData({
            buildingRes: res.building[0],
            statsRes: statsResponse.facets,
            transRes: transResponse,
            tableRes: tableResponse.docs,
            taxRes: taxResponse.facets,
            turnOverRes: turnOverRateResponse,
            allTransactionRes: allTransactionResponses.facets,
            lastTableRes:lastTableResponse
          });
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        setFetchInProgress(false);
        setReportLoaded(true);
        setSubmit(false);
      });
  };

  const _getTransactionData = async (buildingRes) => {
    const fq = [
      "status:sold",
      "transaction_source:ACRIS*",
      "price:[50000 TO *]",
      "parcels_condocoop_count:1",
    ];
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    let q = `(alternate_addresses:("${addressQ}") AND (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}"))`;
    const nestedQ =
      buildingRes.building_status === "sponsor"
        ? "first_closed_date"
        : "close_date_formatted:[NOW-2YEARS TO NOW]";
    const data = {
      q: "*:*",
      sort: "close_date_formatted desc",
      wt: "json",
      fq: fq,
      rows: 0,
      "json.facet": {
        building_stats: {
          type: "query",
          q: q,
          facet: {
            "24_month_sales": {
              type: "query",
              q: nestedQ,
              facet: {
                ppsf: {
                  type: "query",
                  q: "price_per_sqft:[300 TO *]",
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    min_ppsf: "min(price_per_sqft)",
                    avg_ppsf: "avg(price_per_sqft)",
                    max_ppsf: "max(price_per_sqft)",
                    sum_sold_price: "sum(price)",
                    sum_sq_ft: "sum(sq_ft)",
                  },
                },
                dom: {
                  type: "query",
                  q: `days_to_contract:[1 TO 9999] AND ${nestedQ}`,
                  facet: {
                    min_dom: "min(days_to_contract)",
                    avg_dom: "avg(days_to_contract)",
                    median_dom: "percentile(days_to_contract,50)",
                    max_dom: "max(days_to_contract)",
                  },
                },
                discount: {
                  type: "query",
                  q: `discount:[-30 TO 30] AND ${nestedQ}`,
                  facet: {
                    avg_discount: "avg(discount)",
                  },
                },
                // by_bedrooms: {
                //   type: "terms",
                //   field: "bedrooms",
                //   facet: {
                //     avg_price: "avg(price)",
                //     median_price: "percentile(price,50)",
                //     avg_unit_size: "avg(sq_ft)",
                //     med_unit_size: "percentile(sq_ft,0,50,100)",
                //   },
                // },
                by_bedrooms: {
                  type: "query",
                  q: `bedrooms:[0 TO *] AND ${nestedQ}`,

                  facet: {
                    unit_mix: {
                      type: "terms",
                      field: "bedrooms",
                      facet: {
                        avg_unit_size: "avg(sq_ft)",
                        med_unit_size: "percentile(sq_ft,0,50,100)",
                        non_zero_price: {
                          type: "query",
                          q: `price:[100 TO *] AND sq_ft:[100 TO *]`,
                          facet: {
                            avg_unit_size: "avg(sq_ft)",
                            med_unit_size: "percentile(sq_ft,25,50,75)",

                            avg_ppsf: `avg(div(price, sq_ft))`,
                            min_price: `min(price)`,
                            max_price: `max(price)`,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            trends: {
              range: {
                field: "close_date_formatted",
                start: rangeStart,
                end: rangeEnd,
                gap: "+1YEAR",
                facet: {
                  by_stage: {
                    type: "terms",
                    field: "sponsored_sale",
                    limit: 5,
                    facet: {
                      ppsf: {
                        type: "query",
                        q: "price_per_sqft:[300 TO *]",
                        facet: {
                          avg_ppsf: "avg(price_per_sqft)",
                        },
                      },
                    },
                  },
                  avg_ppsf: "avg(price_per_sqft)",
                },
              },
            },

            trends_gap_wise: {
              range: {
                field: "close_date_formatted",
                start: rangeStart,
                end: rangeEnd,
                gap: gap,
                facet: {
                  by_stage: {
                    type: "terms",
                    field: "sponsored_sale",
                    limit: 5,
                    facet: {
                      ppsf: {
                        type: "query",
                        q: "price_per_sqft:[300 TO *]",
                        facet: {
                          avg_ppsf: "avg(price_per_sqft)",
                        },
                      },
                    },
                  },
                  avg_ppsf: "avg(price_per_sqft)",
                },
              },
            },
          },
        },
        neighborhood_stats: {
          type: "query",
          q: `neighborhood:"${buildingRes.neighborhood[0].toLowerCase()}" AND -address_2_normalized:\"\" AND ownership_type:${
            buildingRes.type
          }`,
          facet: {
            "24_month_sales": {
              type: "query",
              q: nestedQ,
              facet: {
                ppsf: {
                  type: "query",
                  q: "price_per_sqft:[300 TO *]",
                  facet: {
                    min_ppsf: "min(price_per_sqft)",
                    avg_ppsf: "avg(price_per_sqft)",
                    max_ppsf: "max(price_per_sqft)",
                    sum_sold_price: "sum(price)",
                    sum_sq_ft: "sum(sq_ft)",
                  },
                },
                dom: {
                  type: "query",
                  q: `days_to_contract:[1 TO 9999] AND ${nestedQ}`,
                  facet: {
                    min_dom: "min(days_to_contract)",
                    avg_dom: "avg(days_to_contract)",
                    median_dom: "percentile(days_to_contract,50)",
                    max_dom: "max(days_to_contract)",
                  },
                },
                discount: {
                  type: "query",
                  q: `discount:[-30 TO 30] AND ${nestedQ}`,
                  facet: {
                    avg_discount: "avg(discount)",
                  },
                },
                // by_bedrooms: {
                //   type: "terms",
                //   field: "bedrooms",
                //   facet: {
                //     avg_price: "avg(price)",
                //     median_price: "percentile(price,50)",
                //     avg_unit_size: "avg(sq_ft)",
                //     med_unit_size: "percentile(sq_ft,0,50,100)",
                //   },
                // },
                by_bedrooms: {
                  type: "query",
                  q: `bedrooms:[0 TO *] AND ${nestedQ}`,
                  sort: "bedrooms:asc",
                  facet: {
                    unit_mix: {
                      type: "terms",
                      field: "bedrooms",
                      facet: {
                        avg_unit_size: "avg(sq_ft)",
                        med_unit_size: "percentile(sq_ft,0,50,100)",
                        non_zero_price: {
                          type: "query",
                          q: `price:[100 TO *] AND sq_ft:[100 TO *]`,
                          facet: {
                            avg_unit_size: "avg(sq_ft)",
                            med_unit_size: "percentile(sq_ft,25,50,75)",

                            avg_ppsf: `avg(div(price, sq_ft))`,
                            min_price: `min(price)`,
                            max_price: `max(price)`,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            trends: {
              range: {
                field: "close_date_formatted",
                start: rangeStart,
                end: rangeEnd,
                gap: "+1YEAR",
                facet: {
                  by_stage: {
                    type: "terms",
                    field: "sponsored_sale",
                    limit: 5,
                    facet: {
                      ppsf: {
                        type: "query",
                        q: "price_per_sqft:[300 TO *]",
                        facet: {
                          avg_ppsf: "avg(price_per_sqft)",
                        },
                      },
                    },
                  },
                  avg_ppsf: "avg(price_per_sqft)",
                },
              },
            },

            trends_gap_wise: {
              range: {
                field: "close_date_formatted",
                start: rangeStart,
                end: rangeEnd,
                gap: gap,
                facet: {
                  by_stage: {
                    type: "terms",
                    field: "sponsored_sale",
                    limit: 5,
                    facet: {
                      ppsf: {
                        type: "query",
                        q: "price_per_sqft:[300 TO *]",
                        facet: {
                          avg_ppsf: "avg(price_per_sqft)",
                        },
                      },
                    },
                  },
                  avg_ppsf: "avg(price_per_sqft)",
                },
              },
            },
          },
        },
        borough_stats: {
          type: "query",
          q: `borough:${buildingRes.borough.toLowerCase()} AND -address_2_normalized:\"\" AND ownership_type:${
            buildingRes.type
          }`,
          facet: {
            "24_month_sales": {
              type: "query",
              q: nestedQ,
              facet: {
                ppsf: {
                  type: "query",
                  q: "price_per_sqft:[300 TO *]",
                  facet: {
                    min_ppsf: "min(price_per_sqft)",
                    avg_ppsf: "avg(price_per_sqft)",
                    max_ppsf: "max(price_per_sqft)",
                    sum_sold_price: "sum(price)",
                    sum_sq_ft: "sum(sq_ft)",
                  },
                },
                dom: {
                  type: "query",
                  q: `days_to_contract:[1 TO 9999] AND ${nestedQ}`,
                  facet: {
                    min_dom: "min(days_to_contract)",
                    avg_dom: "avg(days_to_contract)",
                    median_dom: "percentile(days_to_contract,50)",
                    max_dom: "max(days_to_contract)",
                  },
                },
                discount: {
                  type: "query",
                  q: `discount:[-30 TO 30] AND ${nestedQ}`,
                  facet: {
                    avg_discount: "avg(discount)",
                  },
                },
                // by_bedrooms: {
                //   type: "terms",
                //   field: "bedrooms",
                //   facet: {
                //     avg_price: "avg(price)",
                //     median_price: "percentile(price,50)",
                //     avg_unit_size: "avg(sq_ft)",
                //     med_unit_size: "percentile(sq_ft,0,50,100)",
                //   },
                // },
                by_bedrooms: {
                  type: "query",
                  q: `bedrooms:[0 TO *] AND ${nestedQ}`,
                  sort: "bedrooms:asc",
                  facet: {
                    unit_mix: {
                      type: "terms",
                      field: "bedrooms",
                      facet: {
                        avg_unit_size: "avg(sq_ft)",
                        med_unit_size: "percentile(sq_ft,0,50,100)",
                        non_zero_price: {
                          type: "query",
                          q: `price:[100 TO *] AND sq_ft:[100 TO *]`,
                          facet: {
                            avg_unit_size: "avg(sq_ft)",
                            med_unit_size: "percentile(sq_ft,25,50,75)",

                            avg_ppsf: `avg(div(price, sq_ft))`,
                            min_price: `min(price)`,
                            max_price: `max(price)`,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            trends: {
              range: {
                field: "close_date_formatted",
                start: rangeStart,
                end: rangeEnd,
                gap: "+1YEAR",
                facet: {
                  by_stage: {
                    type: "terms",
                    field: "sponsored_sale",
                    limit: 5,
                    facet: {
                      ppsf: {
                        type: "query",
                        q: "price_per_sqft:[300 TO *]",
                        facet: {
                          avg_ppsf: "avg(price_per_sqft)",
                        },
                      },
                    },
                  },
                  avg_ppsf: "avg(price_per_sqft)",
                },
              },
            },

            trends_gap_wise: {
              range: {
                field: "close_date_formatted",
                start: rangeStart,
                end: rangeEnd,
                gap: gap,
                facet: {
                  by_stage: {
                    type: "terms",
                    field: "sponsored_sale",
                    limit: 5,
                    facet: {
                      ppsf: {
                        type: "query",
                        q: "price_per_sqft:[300 TO *]",
                        facet: {
                          avg_ppsf: "avg(price_per_sqft)",
                        },
                      },
                    },
                  },
                  avg_ppsf: "avg(price_per_sqft)",
                },
              },
            },
          },
        },
      },
    };

    let axiosData = {
      url: apiURL + "/query/we3-transactions?cache=30",
      method: "post",
      query: data,
    };
    let formattedData = await _axiosCall(axiosData);
    return formattedData;
  };
  const getTurnOverBuildingData = async (buildingRes) => {
    const data = {
      q: `(ownership_type:(*${buildingRes.type}*))`,
      fq: [
        "deleted:false",
        'building_status:("sponsor" OR "resale")',
        '-offering_verified_status:"excluded"',
        '(((offering_submitted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_accepted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_verified_status:(active "coming soon" "offering plan required" "offering plan acquired" "condo declaration vetted")) AND offering_verified_status:("" "monitoring" "reviewed" "offering plan required" "offering plan acquired" "condo declaration vetted" "vetting required" "vetted" "coming soon" "active" "sold out") AND deleted:false AND building_status:(pipeline)) OR ((offering_submitted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_accepted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_verified_status:(active "coming soon" "offering plan required" "offering plan acquired" "condo declaration vetted")) AND offering_verified_status:("" "monitoring" "reviewed" "offering plan required" "offering plan acquired" "condo declaration vetted" "vetting required" "vetted" "coming soon" "active" "sold out") AND deleted:false AND building_status:(sponsor)) OR ((ownership_type:(*condo*) AND -ownership_type:condop AND property_category:(resi* mixed*use) AND -full_street_address:"" AND -full_street_address:/.* garage .*/ AND number_of_buildings:[1 TO *] AND (condo_num:[\'1\' TO *] OR (offering_verified_status:active AND building_status:resale)) AND ((tax_assessed_residential_units:[1 TO *] OR building_class:R3 OR (offering_verified_status:active AND building_status:resale)) AND -building_class:R9) AND -offering_verified_status:"excluded" AND deleted:false) AND building_status:resale) OR (ownership_type:(*co?op* *coop* condop*) AND number_of_buildings:[1 TO *] AND -ownership_occupancy_type:rental))',
      ],
      fl: buildingFL,
      sort: "inventory_total desc, id asc",
      wt: "json",
      rows: 0,
      start: 0,
      "json.facet": {
        borough: {
          type: "query",
          q: `(borough:"${buildingRes.borough.toLowerCase()}")`,
          facet: {
            total_inventory: "sum(inventory_total)",
          },
        },
        neighborhood: {
          type: "query",
          q: `(neighborhood:"${buildingRes.neighborhood[0].toLowerCase()}") AND (borough:"${buildingRes.borough.toLowerCase()}")`,
          facet: {
            total_inventory: "sum(inventory_total)",
          },
        },
        // building: {
        //   type: "query",
        //   q: `(alternate_addresses:("${buildingRes.alternate_addresses.join('" OR "')}") AND (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}"))`,
        //   facet: {
        //     total_inventory: "sum(inventory_total)",
        //   },
        // },
      },
    };

    let axiosData = {
      url: apiURL + "/query/we3-buildings?cache=15",
      method: "post",
      query: data,
    };
    let formattedData = await _axiosCall(axiosData);
    console.log(formattedData, "formattedData");
    return formattedData;
  };
  const _getBuildingOPData = async (buildingRes, unitDetails) => {
    const resaleTimePeriod = 2;
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    let q = `(alternate_addresses:("${addressQ}") AND (zip:${
      buildingRes.zip
    } OR borough:"${buildingRes.borough.toLowerCase()}"))`;

    let statsQ = "";

    let isCoop = _isCoop(buildingRes);
    let isHouse = _isHouse(buildingRes);

    if (!isHouse) {
      if (["active"].indexOf(buildingRes.offering_verified_status) >= 0) {
        statsQ = `((offering_verified_status:active AND source_organizations:(CDEC NYAG ADEC) AND baths:[1 TO *]) OR verification_source:(user-verified-valid CDEC ADEC))`;
        q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}))`;
      } else if (
        buildingRes.cdec_date &&
        parseInt(moment(buildingRes.cdec_date).format("YYYY")) > 1970 &&
        !isCoop
      ) {
        let unitSource = "source_organizations:(CDEC ADEC)";
        if (
          buildingRes.cdec_units_properties <
          buildingRes.inventory_total * 0.8
        ) {
          unitSource = `(source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}))`;
        }
        statsQ = `(${unitSource} AND property_type:("" *condo* "resident manager unit" *coop* *affordable*) AND -property_type:*commercial* AND -property_type:*multi*)`;
        q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active \"in contract\")))`;
      } else if (
        ["coming soon"].indexOf(buildingRes.offering_verified_status) >= 0
      ) {
        statsQ = `(source_organizations:NYAG AND offering_baths:[1 TO *] AND offering_price:* AND -offering_file_number:"")`;
        q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active \"in contract\")))`;
      } else if (!isCoop) {
        q += ` AND (source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}) OR (current_status:(active \"in contract\")))`;
      }
    }
    const isResale = ["resale"].indexOf(buildingRes.building_status) >= 0;

    if (statsQ.length > 0) {
      statsQ = "AND " + statsQ;
    }

    q = q;
    const priceField = isResale
      ? "last_sold_price"
      : "last_listed_sale_price_all";
    let fq = [
      "-deleted:true",
      "-offering_unit_abandoned:true",
      '-address_2_normalized:""',
      `-offering_verified_status:stalled`,
    ];
    let fl = [
      ...propertyExportFL,
      ...[
        "floor",
        "line",
        "offering_submitted_date",
        "div(last_sold_price, sq_ft)",
        "div(last_listed_sale_price_all, sq_ft)",
        "div(last_contract_price, sq_ft)",
        "offering_exterior_sq_ft",
        "times_exchanged",
        "last_exchanged_date",
        "*floorplan*",
      ],
    ];
    if (isHouse) {
      fq = [
        "-deleted:true",
        "-offering_unit_abandoned:true",
        'address_2_normalized:""',
      ];
      fl = [...propertyFL, ...["description"]];
    }

    let axiosData = {
      url: apiURL + "/query/" + "we3-properties?cache=15",
      method: "post",
      query: {
        q: q,
        fq: fq,
        fl: fl,
        sort: "floor asc, address_2_normalized asc",
        wt: "json",
        rows: 999,
        "json.facet": {
          has_bed: {
            type: "query",
            q: `bedrooms:[0 TO *] AND -property_type:"resident manager unit"`,
            facet: {
              unit_mix: {
                type: "terms",
                field: "bedrooms",
                facet: {
                  avg_unit_size: "avg(sq_ft)",
                  med_unit_size: "percentile(sq_ft,0,50,100)",

                  non_zero_price: {
                    type: "query",
                    q: `${priceField}:[100 TO *] AND sq_ft:[100 TO *] ${statsQ}`,
                    facet: {
                      avg_unit_size: "avg(sq_ft)",
                      med_unit_size: "percentile(sq_ft,25,50,75)",
                      avg_fees: "avg(offering_monthly_fees)",
                      med_fees: "percentile(offering_monthly_fees,25,50,75)",
                      avg_taxes: "avg(offering_monthly_taxes)",
                      med_taxes: "percentile(offering_monthly_taxes,25,50,75)",
                      avg_ppsf: `avg(div(${priceField}, sq_ft))`,
                      min_price: `min(${priceField})`,
                      max_price: `max(${priceField})`,
                      avg_monthly_carrying_charges:
                        "avg(offering_monthly_carrying_charges)",
                    },
                  },
                  by_status: {
                    type: "terms",
                    field: "offering_status",
                  },
                },
              },
            },
          },
          non_zero_price: {
            type: "query",
            q: `${priceField}:[100000 TO *] AND sq_ft:[100 TO *] ${statsQ} AND property_type:("" *condo* "resident manager unit" *coop* *affordable*) AND -property_type:*commercial* AND -property_type:*multi*`,
            facet: {
              low_price: `min(${priceField})`,
              high_price: `max(${priceField})`,
              average_price: `avg(${priceField})`,
              average_sq_ft: `avg(${priceField})`,
              sum_price: `sum(${priceField})`,
              low_sq_ft: `min(sq_ft)`,
              high_sq_ft: `max(sq_ft)`,
              low_bed: `min(bedrooms)`,
              high_bed: `max(bedrooms)`,
            },
          },
          original_owner: {
            type: "query",
            q: `times_exchanged:[0 TO *] AND owner:* ${statsQ}`,
            facet: {
              times_sold: {
                type: "terms",
                field: "times_sold",
              },
              times_exchanged: {
                type: "terms",
                field: "times_exchanged",
              },
            },
          },
          corp_owner: {
            type: "query",
            q: `(owner:(*LLC *INC *CORP *TRUST *L.P. *AUTHORITY *ASSOCIATES *COMPANY *L.L.C) OR owner:(*llc *inc *corp *trust *l.p. *authority *associates *company *l.l.c)) ${statsQ}`,
          },
        },
      },
    };
    if (isHouse) {
      delete axiosData["query"]["json.facet"];
    }
    let formattedData = await _axiosCall(axiosData);

    return formattedData;
  };

  const _getBuildingTransactionData = async (buildingRes) => {
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    const q = `alternate_addresses:("${addressQ}") AND -address_2_normalized:"" (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}")`;
    const fq = [
      "status:sold",
      "transaction_source:ACRIS*",
      "price:[50000 TO *]",
      "parcels_condocoop_count:1",
    ];
    let axiosData = {
      url: apiURL + "/query/we3-transactions?cache=3600",
      method: "post",
      query: {
        q: q,
        sort: "close_date_formatted desc",
        wt: "json",
        fq: fq,
        rows: 0,
        "json.facet": {
          building_ppsf: {
            type: "query",
            q: `alternate_addresses:("${addressQ}") AND -address_2_normalized:"" (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}") AND price_per_sqft:[300 TO *]`,
            facet: {
              trends: {
                range: {
                  field: "close_date_formatted",
                  start: buildingRes.sales_start_date,
                  end: "NOW",
                  gap: "+1YEAR",
                  facet: {
                    by_stage: {
                      type: "terms",
                      field: "sponsored_sale",
                      limit: 5,
                      facet: {
                        avg_ppsf: "avg(price_per_sqft)",
                      },
                    },
                    avg_ppsf: "avg(price_per_sqft)",
                  },
                },
              },
            },
          },
        },
      },
    };
    let soldStats = await _axiosCall(axiosData);
    const data = [];
    if (soldStats && soldStats.facets && soldStats.facets.building_ppsf) {
      const { buckets } = soldStats.facets.building_ppsf.trends;

      let bedroomStats = {};
      for (let i = 0; i < buckets.length; i++) {
        const bucket = buckets[i];
        if (bucket.count > 0) {
          let item = {};
          let byStage =
            bucket.by_stage && bucket.by_stage.buckets
              ? bucket.by_stage.buckets
              : [];
          item["Year"] = moment(bucket.val).format("YYYY");
          item["Price Per Square Feet"] = bucket.avg_ppsf
            ? bucket.avg_ppsf
            : buckets[i - 1].avg_ppsf;

          item["Number of Sales"] = bucket.count ? bucket.count : 0;
          item["Number of Sponsor Sales"] = byStage.filter(
            (s) => s.val === true
          )[0]
            ? byStage.filter((s) => s.val === true)[0].count
            : 0;
          item["Number of Resales"] = byStage.filter((s) => s.val === false)[0]
            ? byStage.filter((s) => s.val === false)[0].count
            : 0;
          data.push(item);
        }
      }
    }
    return data;
  };

  const _TableData = async (buildingRes) => {
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    let q = `(alternate_addresses:("${addressQ}") AND (zip:${
      buildingRes.zip
    } OR neighborhood:"${buildingRes.neighborhood[0].toLowerCase()}" OR borough:"${
      buildingRes.borough
    }"))`;
  const data={
    "q": q,
    "fq": [
        "source_namespace:(BKMLS REBNY-VOW MARKETPROOF-ONEKEY)",
        "sq_ft:[100 TO *]",
        "listing_type:sale",
        "active_date_start:[NOW-60MONTHS TO NOW]"
    ],
    "fl" : ["display_full_street_address", "address_2_normalized", "price", "sq_ft", "monthly_fees", "monthly_taxes", "active_date_start"],
    "sort": "active_date_start desc",
    "wt": "json",
    "rows": 10,
}
   

    let axiosData = {
      url: apiURL + "/query/search-listings",
      method: "post",
      query: data
    };
    let response = await _axiosCall(axiosData);
    return response;
  };
  
  const _getTaxes = async (buildingRes) => {
    const fq = [
      "source_namespace:(BKMLS REBNY-VOW MARKETPROOF-ONEKEY)",
      "sq_ft:[100 TO *]",
      "listing_type:sale",
      "active_date_start:[NOW-60MONTHS TO NOW]",
    ];
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    let q = `(alternate_addresses:("${addressQ}") AND (zip:${
      buildingRes.zip
    } OR neighborhood:"${buildingRes.neighborhood[0].toLowerCase()}" OR borough:"${
      buildingRes.borough
    }"))`;
    const dataFacet = {
      cc_sf: {
        type: "query",
        q: "monthly_fees:[100 TO *]",
        facet: {
          avg_fee: "avg(monthly_fees)",
          avg: "avg(div(monthly_fees, sq_ft))",
        },
      },
      tax_sf: {
        type: "query",
        q: "monthly_taxes:[100 TO *]",
        facet: {
          avg_tax: "avg(monthly_taxes)",
          avg: "avg(div(monthly_taxes, sq_ft))",
        },
      },
    };
    let axiosData = {
      url: apiURL + "/query/search-listings",
      method: "post",
      query: {
        q: "*:*",
      "fl" : ["display_full_street_address", "address_2_normalized", "price", "sq_ft", "monthly_fees", "monthly_taxes"], 
        sort: "sale_status asc, price desc",
        wt: "json",
        rows: 10,
        fq: fq,
        "json.facet": {
          borough: {
            type: "query",
            q: `(borough:"${buildingRes.borough.toLowerCase()}")`,
            facet: dataFacet,
          },
          neighborhood: {
            type: "query",
             q: `(neighborhood:"${buildingRes.neighborhood[0].toLowerCase()}") AND (borough:"${buildingRes.borough.toLowerCase()}")`,
            facet: dataFacet,
          },
          building: {
            type: "query",
            q: `(alternate_addresses:("${buildingRes.alternate_addresses.join(
              '" OR "'
            )}") AND (zip:${buildingRes.zip} OR borough:"${
              buildingRes.borough
            }"))`,
            facet: dataFacet,
          },
        },
      },
    };
    let response = await _axiosCall(axiosData);
    return response;
  };
  const _getBuildingTransactionTableData = async (buildingRes) => {
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    const fq = [
      `alternate_addresses:("${addressQ}") AND -address_2_normalized:"" (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}")`,
      "status:sold",
      "transaction_source:ACRIS*",
      "price:[50000 TO *]",
      "parcels_condocoop_count:1",
      "-property_type:sr",
      "-property_type:ps",
      "close_date_formatted:[2014-10-30T18:30:00Z TO NOW]",
    ];
    let axiosData = {
      url: apiURL + "/query/we3-transactions?cache=60",
      method: "post",
      query: {
        q: "*:*",
        sort: "close_date_formatted desc",
        wt: "json",
        fq: fq,
        rows: 10,
      },
    };
    let tableData = await _axiosCall(axiosData);

    return tableData;
  };
  // const handleAIGenerate = async (data) => {
  //   console.log(filterAIData(data));
  //   const prompt = `Given the following data give me an analysis that speaks to current period trends vs prior year periods, the chart contains more history.  The analysis should look at root nodes (residential_sales, condo, coop and single_family) and separately analayze  contracts_signed and recorded_sold.  The analysis should be easy to understand for consumer audiences.  For contracts_signed focus only on the count of contracts and days on market (dom), for recorded_sold ignore count and focus on prices.  The analysis should be  concise, 4 to 5 sentences.  Just text.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  Number should be in format ###,###,###  The results should be in valid raw JSON format, no formatting.  { "residential_sales" : { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, condo : { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, coop: { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, single_family: { contracts_signed: "analysis in text", recorded_sales: "analysis in text"} }

  //   The report contains the following key stats:${JSON.stringify(
  //     filterAIData(data)
  //   )}

  //   The report's geography focuses on ${summarizeGeographies(searchTags)}

  //   Current Period: ${currentPeriodName}
  //   Prior Year Period: ${priorYearPeriodName}`;
  //   const queryData = {
  //     messages: [
  //       {
  //         role: "system",
  //         content: `You are a NYC real estate expert that provides insightly data-driven analysis that are easy to understand.  You speak in a professional yet friendly manner.  Think TV news analysts.`,
  //       },
  //       { role: "user", content: prompt },
  //     ],
  //     model: "gpt-4o",
  //     response_format: { type: "json_object" },
  //   };

  //   const axiosData = {
  //     url: apiURL + "/ai/chat",
  //     method: "post",
  //     query: queryData,
  //   };
  //   let aiResponse = {};
  //   try {
  //     const res = await _axiosCall(axiosData);
  //     console.log(res);

  //     if (
  //       res &&
  //       res.choices &&
  //       res.choices[0] &&
  //       res.choices[0].message &&
  //       res.choices[0].message.content
  //     ) {
  //       const result = res.choices[0].message.content;

  //       try {
  //         aiResponse = JSON.parse(result);
  //         console.log(aiResponse);
  //       } catch (e) {}
  //     }
  //   } catch (error) {
  //     console.log("Error generating summary:", error);
  //   }
  //   return aiResponse;
  // };
  if (!reportData) return null;
  const calculatePercentage = (count, total) => {
    if (total === 0 || total === undefined) return "";
    const percentage = (count / total) * 100;
    return `${Math.round(percentage) / 2}%`;
  };
  const calculateOwnerData = () => {
    const statsRes = reportData.statsRes;
    let totalOriginal =
      statsRes.original_owner &&
      statsRes.original_owner.times_exchanged &&
      statsRes.original_owner.times_exchanged.buckets &&
      statsRes.original_owner.times_exchanged.buckets.filter(
        (item) => item.val === 1
      ).length > 0
        ? statsRes.original_owner.times_exchanged.buckets.filter(
            (item) => item.val === 1
          )[0].count
        : 0;

    const totalAvail =
      statsRes.original_owner && statsRes.original_owner.count
        ? statsRes.original_owner.count - totalOriginal
        : 0;
    console.log(totalOriginal, totalAvail, "totalOriginal");
    const data = [{ value: totalOriginal }, { value: totalAvail }];
    return data[0].value > 0
      ? parseFloat(
          (data[0].value /
            (data[0].value + (data[1].value ? data[1].value : 0))) *
            100
        ).toFixed(0) + "%"
      : "--";
  };

  const calculateCorporateData = () => {
    const statsRes = reportData.statsRes;
    let totalOriginal =
      statsRes.corp_owner && statsRes.corp_owner.count
        ? statsRes.corp_owner && statsRes.corp_owner.count
        : 0;

    const totalAvail = statsRes.count ? statsRes.count - totalOriginal : 0;
    const data = [{ value: totalOriginal }, { value: totalAvail }];
    return data[0].value > 0
      ? parseFloat(
          (data[0].value /
            (data[0].value + (data[1].value ? data[1].value : 0))) *
            100
        ).toFixed(0) + "%"
      : "0%";
  };

  const generateUnitMixData = () => {
    const statsRes = reportData.statsRes;

    if (!statsRes.has_bed.unit_mix.buckets) {
      return [];
    }

    // Initialize the data array with name, color, and search keys
    const data = [
      {
        name: "Studio",
        value: 0,
        unsold: 0,
        sold: 0,
        contract: 0,
        search: "studio",
      },
      {
        name: "1 Bed",
        value: 0,
        unsold: 0,
        sold: 0,
        contract: 0,
        search: "1-bedroom",
      },
      {
        name: "2 Bed",
        value: 0,
        unsold: 0,
        sold: 0,
        contract: 0,
        search: "2-bedroom",
      },
      {
        name: "3 Bed",
        value: 0,
        unsold: 0,
        sold: 0,
        contract: 0,
        search: "3-bedroom",
      },
      {
        name: "4+ Bed",
        value: 0,
        unsold: 0,
        sold: 0,
        contract: 0,
        search: "4-or-more",
      },
    ];

    statsRes.has_bed.unit_mix.buckets
      .sort((a, b) => a.val - b.val)
      .forEach((bucket) => {
        if (bucket.val >= 0 && bucket.val < 4) {
          data[bucket.val].value = bucket.count;
          data[bucket.val].unsold = bucket.count;

          if (bucket.by_status.buckets) {
            bucket.by_status.buckets.forEach((status) => {
              if (
                [
                  "sold",
                  "not_yet_recorded",
                  "in contract",
                  "pending",
                  "bulk sold",
                ].includes(status.val)
              ) {
                data[bucket.val].sold += status.count;
                data[bucket.val].unsold -= status.count;
              }
            });
          }
        } else {
          data[4].value += bucket.count;
          data[4].unsold += bucket.count;

          if (bucket.by_status.buckets) {
            bucket.by_status.buckets.forEach((status) => {
              if (
                [
                  "sold",
                  "not_yet_recorded",
                  "in contract",
                  "pending",
                  "bulk sold",
                ].includes(status.val)
              ) {
                data[4].sold += status.count;
                data[4].unsold -= status.count;
              }
            });
          }
        }
      });
    return data;
  };
  const _generateSalesDataBreakdown = () => {
    const statsRes =
      reportData.allTransactionRes.building_stats["24_month_sales"];
    if (
      !statsRes ||
      !statsRes.by_bedrooms ||
      !statsRes.by_bedrooms.unit_mix ||
      !statsRes.by_bedrooms.unit_mix.buckets
    ) {
      return [];
    }
    const total = statsRes.by_bedrooms.unit_mix.buckets
      .map((bucket) => bucket.count)
      .reduce((accumulator, current) => {
        return accumulator + current;
      }, 0);
    let other = 0;
    let data = statsRes.by_bedrooms.unit_mix.buckets
      .sort((a, b) => a.val - b.val)
      .map((bucket, i) => {
        const stat = bucket.non_zero_price ? bucket.non_zero_price : false;
        return {
          name: bucket.val > 0 ? `${bucket.val} Bed` : `Studio`,
          count: bucket.count,
          size: bucket.avg_unit_size,
          price: stat.avg_ppsf,
          carrying_cost: stat.avg_monthly_carrying_charges,
          avg_fees: stat.avg_fees,
          min_price: stat.min_price,
          max_price: stat.max_price,
          search:
            bucket.val == 0
              ? "studio"
              : bucket.val > 3
              ? "4-or-more"
              : bucket.val + "-bedroom",
        };
      });

    return data;
  };

  const stats = [
    {
      value:
        validateNestedData(
          reportData,
          "allTransactionRes.building_stats.24_month_sales.ppsf.sum_sold_price"
        ) &&
        validateNestedData(
          reportData,
          "allTransactionRes.building_stats.24_month_sales.ppsf.sum_sq_ft"
        )
          ? `$${_formatNumber(
              reportData.allTransactionRes.building_stats["24_month_sales"].ppsf
                .sum_sold_price /
                reportData.allTransactionRes.building_stats["24_month_sales"]
                  .ppsf.sum_sq_ft
            )}`
          : "--",
      label: "Sold Price / Sq Ft",
    },

    {
      value:
        validateNestedData(reportData, "taxRes.building.cc_sf.avg") &&
        validateNestedData(reportData, "taxRes.building.tax_sf.avg_tax")
          ? `$${
              (reportData.taxRes.building.cc_sf.avg +
                reportData.taxRes.building.tax_sf.avg_tax).toFixed(2)
            } / sf / mo`
          : "--",
      label: "Carrying Cost / Sq Ft / Mo",
    },
    {
      value:
        validateNestedData(
          reportData,
          "allTransactionRes.building_stats.24_month_sales.count"
        ) && validateNestedData(reportData, "buildingRes.inventory_total")
          ? `${calculatePercentage(
              reportData.allTransactionRes.building_stats["24_month_sales"]
                .count,
              reportData.buildingRes.inventory_total
            )}`
          : "--",
      label: "Annual Turnover Rate",
    },
    { value: calculateOwnerData(), label: "Original Owners" },
    { value: calculateCorporateData(), label: "Owned by Corporate Entity" },
  ];
  const content = [
    "Key Stats",
    "How it compares",
    "Closed Sales",
    "Price Trends",
    "Latest Activity",
  ];

  const cardStats = [
    {
      location: validateNestedData(
        reportData,
        "buildingRes.display_full_street_address"
      )
        ? reportData.buildingRes.display_full_street_address
        : "--",
      items: [
        {
          label: "Price / Sq Ft",

          value: validateNestedData(
            reportData,
            "allTransactionRes.building_stats.24_month_sales.ppsf.avg_ppsf"
          )
            ? `$${_formatNumber(
                reportData.allTransactionRes.building_stats["24_month_sales"]
                  .ppsf.avg_ppsf
              )}`
            : "--",
        },
        {
          label: "Turnover Rate",
          value:
            validateNestedData(
              reportData,
              "allTransactionRes.building_stats.24_month_sales.count"
            ) && validateNestedData(reportData, "buildingRes.inventory_total")
              ? `${calculatePercentage(
                  reportData.allTransactionRes.building_stats["24_month_sales"]
                    .count,
                  reportData.buildingRes.inventory_total
                )} / Yr`
              : "--",
        },
        {
          label: "YoY Appreciation",
          value:
            reportData &&
            reportData.allTransactionRes &&
            reportData.allTransactionRes.building_stats &&
            reportData.allTransactionRes.building_stats.trends &&
            reportData.allTransactionRes.building_stats.trends.buckets &&
            reportData.allTransactionRes.building_stats.trends.buckets.length >=
              2 &&
            reportData.allTransactionRes.building_stats.trends.buckets[
              reportData.allTransactionRes.building_stats.trends.buckets
                .length - 1
            ] &&
            reportData.allTransactionRes.building_stats.trends.buckets[
              reportData.allTransactionRes.building_stats.trends.buckets
                .length - 1
            ].avg_ppsf &&
            reportData.allTransactionRes.building_stats.trends.buckets[
              reportData.allTransactionRes.building_stats.trends.buckets
                .length - 2
            ] &&
            reportData.allTransactionRes.building_stats.trends.buckets[
              reportData.allTransactionRes.building_stats.trends.buckets
                .length - 2
            ].avg_ppsf
              ? `${percentageChange(
                  reportData.allTransactionRes.building_stats.trends.buckets[
                    reportData.allTransactionRes.building_stats.trends.buckets
                      .length - 1
                  ].avg_ppsf,
                  reportData.allTransactionRes.building_stats.trends.buckets[
                    reportData.allTransactionRes.building_stats.trends.buckets
                      .length - 2
                  ].avg_ppsf
                )}%`
              : "0",
        },
        {
          label: "Common Charges",
          value: validateNestedData(reportData, "taxRes.building.cc_sf.avg")
            ? `$${reportData.taxRes.building.cc_sf.avg.toFixed(2)} / sf / mo`
            : "--",
        },
        {
          label: "RE Taxes",
          value: validateNestedData(
            reportData,
            "taxRes.building.tax_sf.avg_tax"
          )
            ? `$${reportData.taxRes.building.tax_sf.avg_tax.toFixed(
                2
              )} / sf / mo`
            : "--",
        },
      ],
      className: "dark",
    },
    {
      location: reportData.buildingRes.neighborhood[0],
      items: [
        {
          label: "Price / Sq Ft",
          value: validateNestedData(
            reportData,
            "allTransactionRes.neighborhood_stats.24_month_sales.ppsf.avg_ppsf"
          )
            ? `$${_formatNumber(
                reportData.allTransactionRes.neighborhood_stats[
                  "24_month_sales"
                ].ppsf.avg_ppsf
              )}`
            : "--",
        },
        {
          label: "Turnover Rate",
          value:
            validateNestedData(
              reportData,
              "turnOverRes.facets.neighborhood.total_inventory"
            ) &&
            validateNestedData(
              reportData,
              "allTransactionRes.neighborhood_stats.24_month_sales.count"
            )
              ? `${calculatePercentage(
                  reportData.turnOverRes.facets.neighborhood.total_inventory,
                  reportData.allTransactionRes.neighborhood_stats[
                    "24_month_sales"
                  ].count
                )} / Yr`
              : "--",
        },
        {
          label: "YoY Appreciation",
          value:
            reportData &&
            reportData.allTransactionRes &&
            reportData.allTransactionRes.neighborhood_stats &&
            reportData.allTransactionRes.neighborhood_stats.trends &&
            reportData.allTransactionRes.neighborhood_stats.trends.buckets &&
            reportData.allTransactionRes.neighborhood_stats.trends.buckets
              .length >= 2 &&
            reportData.allTransactionRes.neighborhood_stats.trends.buckets[
              reportData.allTransactionRes.neighborhood_stats.trends.buckets
                .length - 1
            ] &&
            reportData.allTransactionRes.neighborhood_stats.trends.buckets[
              reportData.allTransactionRes.neighborhood_stats.trends.buckets
                .length - 1
            ].avg_ppsf &&
            reportData.allTransactionRes.neighborhood_stats.trends.buckets[
              reportData.allTransactionRes.neighborhood_stats.trends.buckets
                .length - 2
            ] &&
            reportData.allTransactionRes.neighborhood_stats.trends.buckets[
              reportData.allTransactionRes.neighborhood_stats.trends.buckets
                .length - 2
            ].avg_ppsf
              ? `${percentageChange(
                  reportData.allTransactionRes.neighborhood_stats.trends
                    .buckets[
                    reportData.allTransactionRes.neighborhood_stats.trends
                      .buckets.length - 1
                  ].avg_ppsf,
                  reportData.allTransactionRes.neighborhood_stats.trends
                    .buckets[
                    reportData.allTransactionRes.neighborhood_stats.trends
                      .buckets.length - 2
                  ].avg_ppsf
                )}%`
              : "0",
        },
        {
          label: "Common Charges",
          value: validateNestedData(reportData, "taxRes.neighborhood.cc_sf.avg")
            ? `$${reportData.taxRes.neighborhood.cc_sf.avg.toFixed(
                2
              )} / sf / mo`
            : "--",
        },
        {
          label: "RE Taxes",
          value: validateNestedData(
            reportData,
            "taxRes.neighborhood.tax_sf.avg_tax"
          )
            ? `$${reportData.taxRes.neighborhood.tax_sf.avg_tax.toFixed(
                2
              )} / sf / mo`
            : "--",
        },
      ],
      className: "light",
    },
    {
      location: reportData.buildingRes.borough,
      items: [
        {
          label: "Price / Sq Ft",
          value: validateNestedData(
            reportData,
            "allTransactionRes.borough_stats.24_month_sales.ppsf.avg_ppsf"
          )
            ? `$${_formatNumber(
                reportData.allTransactionRes.borough_stats["24_month_sales"]
                  .ppsf.avg_ppsf
              )}`
            : "--",
        },
        {
          label: "Turnover Rate",
          value:
            validateNestedData(
              reportData,
              "turnOverRes.facets.borough.total_inventory"
            ) &&
            validateNestedData(
              reportData,
              "allTransactionRes.borough_stats.24_month_sales.count"
            )
              ? `${calculatePercentage(
                  reportData.turnOverRes.facets.borough.total_inventory,
                  reportData.allTransactionRes.borough_stats["24_month_sales"]
                    .count
                )} / Yr`
              : "--",
        },
        {
          label: "YoY Appreciation",
          value:
            reportData.allTransactionRes &&
            reportData.allTransactionRes.borough_stats &&
            reportData.allTransactionRes.borough_stats.trends &&
            reportData.allTransactionRes.borough_stats.trends.buckets &&
            reportData.allTransactionRes.borough_stats.trends.buckets.length &&
            reportData.allTransactionRes &&
            reportData.allTransactionRes.borough_stats &&
            reportData.allTransactionRes.borough_stats.trends &&
            reportData.allTransactionRes.borough_stats.trends.buckets &&
            reportData.allTransactionRes.borough_stats.trends.buckets.length >=
              2 &&
            reportData.allTransactionRes.borough_stats.trends.buckets[
              reportData.allTransactionRes.borough_stats.trends.buckets.length -
                1
            ] &&
            reportData.allTransactionRes.borough_stats.trends.buckets[
              reportData.allTransactionRes.borough_stats.trends.buckets.length -
                1
            ].avg_ppsf &&
            reportData.allTransactionRes.borough_stats.trends.buckets[
              reportData.allTransactionRes.borough_stats.trends.buckets.length -
                2
            ] &&
            reportData.allTransactionRes.borough_stats.trends.buckets[
              reportData.allTransactionRes.borough_stats.trends.buckets.length -
                2
            ].avg_ppsf
              ? `${percentageChange(
                  reportData.allTransactionRes.borough_stats.trends.buckets[
                    reportData.allTransactionRes.borough_stats.trends.buckets
                      .length - 1
                  ].avg_ppsf,
                  reportData.allTransactionRes.borough_stats.trends.buckets[
                    reportData.allTransactionRes.borough_stats.trends.buckets
                      .length - 2
                  ].avg_ppsf
                )}%`
              : "01",
        },
        {
          label: "Common Charges",
          value: validateNestedData(reportData, "taxRes.borough.cc_sf.avg")
            ? `$${reportData.taxRes.borough.cc_sf.avg.toFixed(2)} / sf / mo`
            : "--",
        },
        {
          label: "RE Taxes",
          value: validateNestedData(reportData, "taxRes.borough.tax_sf.avg_tax")
            ? `$${reportData.taxRes.borough.tax_sf.avg_tax.toFixed(
                2
              )} / sf / mo`
            : "--",
        },
      ],
      className: "light",
    },
  ];

  const _generateUnitMixBreakdown = (statsRes) => {
    if (
      !statsRes.has_bed ||
      !statsRes.has_bed.unit_mix ||
      !statsRes.has_bed.unit_mix.buckets
    ) {
      return [];
    }
    const total = statsRes.has_bed.unit_mix.buckets
      .map((bucket) => bucket.count)
      .reduce((accumulator, current) => {
        return accumulator + current;
      }, 0);
    let other = 0;
    let data = statsRes.has_bed.unit_mix.buckets
      .sort((a, b) => a.val - b.val)
      .map((bucket, i) => {
        const stat = bucket.non_zero_price ? bucket.non_zero_price : false;
        return {
          name: bucket.val > 0 ? `${bucket.val} Bed` : `Studio`,
          count: bucket.count,
          size: bucket.avg_unit_size,
          price: stat.avg_ppsf,
          carrying_cost: stat.avg_monthly_carrying_charges,
          avg_fees: stat.avg_fees,
          min_price: stat.min_price,
          max_price: stat.max_price,
          search:
            bucket.val == 0
              ? "studio"
              : bucket.val > 3
              ? "4-or-more"
              : bucket.val + "-bedroom",
        };
      });

    return data;
  };
  console.log(_generateUnitMixBreakdown(reportData.statsRes), "mixData");
  const BarSalesData = _generateSalesDataBreakdown();

  return (
    <>
      <div className="page-section report-container building-view-page-1">
        <div className="building-view-report-container-2 ">
          <section className="building-report-introduction report-section">
            <div className="building-enterprise-content dark">
              <div className="enterprise-name">Market Proof</div>
              <div className="report-name">Building</div>
              <div className="report-name name-2">Report</div>
              <div className="building-view-2-location">
                {reportData.buildingRes.display_full_street_address}
              </div>
              <div className="building-view-2-year">{currentPeriodName}</div>
            </div>
            <img src={logo} alt="img" />
          </section>
          <div className="building-report-introduction-bottom-content">
            {content.map((title) => {
              return <div>{title}</div>;
            })}
          </div>
        </div>
      </div>
      <div className="report-container page-section">
        <section className="building-view-top-header">
          <Header title="Key Stats" subText="marketproof.com" />
        </section>
        <div className="building-view-2-report-inner page-start">
          <section className="report-section">
            <div className="light">
              <h2 className="section-title">THIS REPORT</h2>

              <p>
                This report, presented by Marketproof, provides a detailed
                overview of market activity and key trends for residents. It
                offers insights into the latest property listings, contracts,
                and sales, helping you stay informed about changes within your
                building.
              </p>
              <p>
                You'll also find an easily understandable analysis of price
                trends, a summary of recently closed sales, and a comparison to
                similar properties in the area, giving you a clear picture of
                how your building measures up.
              </p>
              <p>
                Finally, this report provides ideas for how to maximize the
                value of the residences in your building.
              </p>
            </div>
            <div className={theme === "custom" ? "" : "dark"}>
              <h2 className="section-title">MARKETPROOF</h2>
              <p>
                Marketproof is a leading real estate intelligence and analytics
                company dedicated to making complex real estate data accessible
                and actionable.
              </p>
              <p>
                We deliver the information and insights you need to make
                informed, confident decisions in an ever-changing market.
              </p>
              <p>
                As a trusted and independent resource, we empower clients to
                achieve greater success by leveraging data-driven intelligence.
              </p>
              <div className="contact-info">
                <p>marketproof.com</p>
                <p>info@marketproof.com</p>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="report-container page-section building-view-page-3">
        <section className="building-view-top-header">
          <Header
            title="About"
            subText="marketproof.com"
            subTitle={reportData.buildingRes.display_full_street_address}
          />
        </section>
        <div className="building-view-2-report-inner page-start">
          <section className="report-section">
            <div className="report-section light">
              <p>
                221 West 77th Street outperforms condos in the Upper West Side
                and Manhattan, boasting a +3.9% year-over-year appreciation and
                a $2,833/sf price—well above the neighborhood (+0.93%,
                $1,639/sf) and borough (-3.8%, $1,728/sf) averages.
              </p>
              <p>
                Its 11.5% turnover rate, significantly higher than the
                neighborhood (4.2%) and borough (4.9%) averages, highlights
                heightened sales activity. Coupled with competitive common
                charges of $1.35/sf/month, the building solidifies its
                desirability as a luxury Manhattan condo.
              </p>
              <div className="building-view-2-horizontal-chart">
                <h2 className="section-title">THIS UNIT</h2>
                <HorizontalBarChart
                  theme={theme}
                  data={generateUnitMixData().map((item) => ({
                    name: item.name,
                    value: !item.value ? 4 : item.value,
                    barDisplayInnerValue: !item.sold ? "None" : item.sold,
                  }))}
                  radius={false}
                  alignment={false}
                  height={500}
                  noSign={true}
                />
              </div>
            </div>
            <div className="page-3-right-content">
              <Details
                data={[
                  {
                    text: reportData.buildingRes.total_floors,
                    subText: "Floors",
                  },
                  {
                    text: reportData.buildingRes.inventory_total,
                    subText: "Units",
                  },
                ]}
              />
              <Details
                data={[
                  reportData.buildingRes.year_converted !== -1
                    ? {
                        subText: "Year Converted",
                        text: reportData.buildingRes.year_converted,
                      }
                    : {
                        text: reportData.buildingRes.year_built,
                        subText: "Year Built",
                      },
                  {
                    text: reportData.buildingRes.ownership_type,
                    subText: "Ownership",
                  },
                ]}
              />
              <div className="stats-card dark">
                <div className="stats-section">
                  {stats.map((stat, index) => (
                    <div key={index} className="stat-item">
                      <p className="stat-value">{stat.value}</p>
                      <p className="stat-label">{stat.label}</p>
                      {index !== stats.length - 1 && <hr />}
                    </div>
                  ))}
                </div>
                <div className="empty-section"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="report-container page-section building-view-page-4">
        <section className="building-view-top-header">
          <Header
            title="How It Compares"
            subText="marketproof.com"
            subTitle={reportData.buildingRes.display_full_street_address}
          />
        </section>
        <section className="report-section">
          <div className="content-cont">
            <div className="desc">
              This report compares 221 West 77th Street to condos in the Upper
              West Side and Manhattan, highlighting its performance across key
              metrics for current residents.
            </div>
            <div className="comparison-stats">
              {cardStats.map((stat, index) => (
                <div key={index} className={`stats-column ${stat.className}`}>
                  <h3 className="location-title">{stat.location}</h3>
                  {stat.items.map((item, idx) => (
                    <div key={idx} className="stat-item">
                      <p className="stat-label">
                        <ArrowRightCircleOutlineIcon />
                        {item.label}
                      </p>
                      <p className="stat-value">{item.value}</p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <div className="report-container page-section building-view-page-5">
        <section className="building-view-top-header">
          <Header
            title="Closed Sales"
            subText="marketproof.com"
            subTitle="221 West 77th Street"
          />
        </section>
        <section className="report-section">
          <div className="content-cont">
            <h2 className="section-title">24-MONTH SALES</h2>
            <div className="chart-comp">
             {BarSalesData.length ? <CustomBarChart
                data={
                  BarSalesData.length &&
                  BarSalesData.map((item) => ({ ...item, value: item.count }))
                }
                theme={theme}
                height={475}
                noSpecialChar={true}
                upperLabel={false}
              />:null}
              <div>
                <Details
                  data={[
                    {
                      text: validateNestedData(
                        reportData,
                        "allTransactionRes.building_stats.24_month_sales.count"
                      )
                        ? reportData.allTransactionRes.building_stats[
                            "24_month_sales"
                          ].count
                        : "--",
                      subText: "Number of Sales",
                    },
                  ]}
                />
                <Details
                  data={[
                    {
                      text:
                        validateNestedData(
                          reportData,
                          "allTransactionRes.building_stats.24_month_sales.count"
                        ) &&
                        validateNestedData(
                          reportData,
                          "buildingRes.inventory_total"
                        )
                          ? `${calculatePercentage(
                              reportData.allTransactionRes.building_stats[
                                "24_month_sales"
                              ].count,
                              reportData.buildingRes.inventory_total
                            )}`
                          : "0",
                      subText: "Annual TurnOver",
                    },
                  ]}
                />
                <Details
                  data={[
                    {
                      text: validateNestedData(
                        reportData,
                        "allTransactionRes.building_stats.24_month_sales.dom.avg_dom"
                      )
                        ? `${_formatNumber(
                            reportData.allTransactionRes.building_stats[
                              "24_month_sales"
                            ].dom.avg_dom
                          )}`
                        : "0",
                      subText: "Average Days on Market",
                    },
                  ]}
                />
              </div>
            </div>
            <div className="desc">
              21 West 77th Street showed above average sales activity, with an
              11.5% annual turnover rate and an average of 110 days on the
              market. Recent activity shows consistent demand across unit types,
              supported by a mix of sponsor sales and resales over the years
            </div>
            <div className="dark">
              <h2 className="section-title">SALES BY YEAR</h2>
           {reportData.transRes.length ?    <MultiBarChart
                data={
                  reportData.transRes &&
                  reportData.transRes.map((item) => ({
                    ...item,
                    total:
                      item["Number of Sponsor Sales"] +
                      item["Number of Resales"],
                  }))
                }
                theme={theme}
                style={formValues.style}
                height={500}
                buildingRes={reportData.buildingRes}
              />:null}
            </div>
          </div>
        </section>
      </div>

      <div className="report-container page-section building-view-page-6">
        <section className="building-view-top-header">
          <Header
            title="Price Trend"
            subText="marketproof.com"
            subTitle={reportData.buildingRes.display_full_street_address}
          />
        </section>
        <section className="report-section">
          <div className="content-cont">
            <div className="desc">
              The following highlights 221 West 77th Street's strong pricing,
              with an average sold price of $2,833/sf, +3.9% year-over-year
              appreciation, and a -8.2% discount from asking. Premium pricing
              across unit types underscores its appeal in the Upper West Side
              market.
            </div>
            <h2 className="section-title">AVERAGE PRICE / SQ FT</h2>
           {reportData.transRes.length ?  <CustomLineChart
              theme={theme}
              data={
              
                   reportData.transRes.map((item) => ({
                      year: item.Year,
                      price: item["Price Per Square Feet"],
                    }))
                  
              }
              height={500}
            />:null}

            <div className="dark">
              <h2 className="section-title">24-MONTH SALES</h2>
              <div className="chart-comp">
               {BarSalesData.length ?  <CustomBarChart
                  data={
                    BarSalesData.length &&
                    BarSalesData.map((item) => ({
                      name: item.name,
                      price: Math.ceil(item.price),
                      value: Math.ceil(item.price),
                    }))
                  }
                  theme={theme}
                  height={420}
                  formatterPrice={false}
                />:null}
                <div>
                  <Details
                    data={[
                      {
                        text: validateNestedData(
                          reportData,
                          "allTransactionRes.building_stats.24_month_sales.ppsf.avg_ppsf"
                        )
                          ? `${_formatNumber(
                              reportData.allTransactionRes.building_stats[
                                "24_month_sales"
                              ].ppsf.avg_ppsf
                            )}`
                          : "--",
                        subText: "Average Sold Price /Sq ft",
                      },
                    ]}
                  />
                  <Details
                    data={[
                      {
                        text:
                          reportData &&
                          reportData.allTransactionRes &&
                          reportData.allTransactionRes.building_stats &&
                          reportData.allTransactionRes.building_stats.trends &&
                          reportData.allTransactionRes.building_stats.trends
                            .buckets &&
                          reportData.allTransactionRes.building_stats.trends
                            .buckets.length >= 2 &&
                          reportData.allTransactionRes.building_stats.trends
                            .buckets[
                            reportData.allTransactionRes.building_stats.trends
                              .buckets.length - 1
                          ] &&
                          reportData.allTransactionRes.building_stats.trends
                            .buckets[
                            reportData.allTransactionRes.building_stats.trends
                              .buckets.length - 1
                          ].avg_ppsf &&
                          reportData.allTransactionRes.building_stats.trends
                            .buckets[
                            reportData.allTransactionRes.building_stats.trends
                              .buckets.length - 2
                          ] &&
                          reportData.allTransactionRes.building_stats.trends
                            .buckets[
                            reportData.allTransactionRes.building_stats.trends
                              .buckets.length - 2
                          ].avg_ppsf
                            ? `${percentageChange(
                                reportData.allTransactionRes.building_stats
                                  .trends.buckets[
                                  reportData.allTransactionRes.building_stats
                                    .trends.buckets.length - 1
                                ].avg_ppsf,
                                reportData.allTransactionRes.building_stats
                                  .trends.buckets[
                                  reportData.allTransactionRes.building_stats
                                    .trends.buckets.length - 2
                                ].avg_ppsf
                              )}%`
                            : "0",
                        subText: "Year Over Year Appreciation",
                      },
                    ]}
                  />
                  <Details
                    data={[
                      {
                        text: validateNestedData(
                          reportData,
                          "allTransactionRes.building_stats.24_month_sales.discount.avg_discount"
                        )
                          ? _formatNumber(
                              reportData.allTransactionRes.building_stats[
                                "24_month_sales"
                              ].discount.avg_discount.toFixed(1)
                            ) + "%"
                          : "--",
                        subText: "Discount from Asking Price",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="report-container page-section building-view-page-7">
        <section className="building-view-top-header">
          <Header
            title="Latest Activity"
            subText="marketproof.com"
            subTitle={reportData.buildingRes.display_full_street_address}
          />
        </section>
        {console.log(reportData, "reportData")}
        <section className="report-section">
          <div className="content-cont">
            <h2 className="section-title">RECENTLY SOLD</h2>
            <CustomTable
              headers={[
                "DATE",
                "UNIT",
                "BED/BATH",
                "SQ FT",
                "SOLD PRICE",
                "SOLD PPSF",
              ]}
              rows={reportData.tableRes.map((item) => [
                item.close_date_formatted !== -1
                  ? formatDate(item.close_date_formatted)
                  : "--",
                item.address_2_normalized !== -1
                  ? item.address_2_normalized.toUpperCase()
                  : "--",
                item.bedrooms !== -1 && item.baths !== -1
                  ? `${item.bedrooms} / ${item.baths}`
                  : "--",
                item.sq_ft !== -1 ? `${_formatNumber(item.sq_ft)} Sq ft` : "--",
                item.price !== -1 ? `$${_formatNumber(item.price)}` : "--",
                item.price_per_sqft !== -1
                  ? `${_formatNumber(item.price_per_sqft)}`
                  : "--",
              ])}
              theme={theme}
              color={color}
            />
            <div className="dark dark-table">
              <h2 className="section-title">SALES BY YEAR</h2>
              <CustomTable
                headers={[
                  "DATE",
                  "UNIT",
                  "MONTHLY FEES",
                  "MONTHLY TAXES",
                  "SQ FT",
                  "ASK PRICE",
                ]}
                rows={reportData.lastTableRes.docs.map((item) => [
                  item.active_date_start !==-1
                    ? formatDate(item.active_date_start)
                    : "--",
                  item.address_2_normalized !==-1
                    ? item.address_2_normalized.toUpperCase()
                    : "--",
                  item.monthly_fees !==-1
                    ? `${item.monthly_fees}`
                    : "--",
                    item.monthly_taxes !==-1
                    ? `${item.monthly_taxes}`
                    : "--",
                  item.sq_ft !==-1 ? `${_formatNumber(item.sq_ft)} Sq ft` : "--",
                  item.price !==-1 ? `$${_formatNumber(item.price)}` : "--",
               
                ])}
                theme={theme}
                color={color}
              />
            </div>
          </div>
        </section>
      </div>

      <div className="report-container page-section building-view-page-8">
        <section className="building-view-top-header">
          <Header title="Contact Us" />
        </section>
        <section className="report-section">
          <div className="content-cont dark">
            <div className="contact_wrapper">
              <div className="contact_details">
                <div>
                  <span>Email</span>
                  <span>info@marketproof.com</span>
                </div>
                <div>
                  <span>Website</span>
                  <span>marketproof.com</span>
                </div>
              </div>
            </div>
            <div className="detail-content">
              <div>
                <div className="enterprise-name">Market Proof</div>
                <div className="report-name">Building</div>
                <div className="report-name name-2">Report</div>
              </div>
              <img src={logo} alt="img" />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BlendedLayout;
